// extracted by mini-css-extract-plugin
export var sectiontitle = "SectionTitle-module--sectiontitle--1E_jf";
export var fadeOutAnimation = "SectionTitle-module--fadeOutAnimation--3Exti";
export var fadeInAnimation = "SectionTitle-module--fadeInAnimation--2c82S";